import { useCallback } from 'react';
import { appConfig } from '../config/app.config';
import { useAppSelector } from './redux.hook';

declare global {
  interface Window {
    YaAuthSuggest: any
  }
}

export const useYandexId = () => {
  const { enableYandexId } = useAppSelector(state => state.settings);

  const init = useCallback(async (callback?: () => void) => {
    if (!enableYandexId) return undefined;

    return new Promise<any>(resolve => {
      window.YaAuthSuggest.init({
        client_id: appConfig().ya_client_id,
        response_type: 'token'
      },
        'https://cdn.reserve-donkin-leads.ru',
        {
          view: 'button',
          parentId: 'yandex_id_container',
          buttonView: 'main',
          buttonTheme: 'light',
          buttonSize: 'xxl',
          buttonBorderRadius: 6
        })
        .then(({ handler }) => {
          callback && callback();
          return handler();
        })
        .then(data => {
          return resolve(data);
        })
        .catch(error => console.log(error));
    });
  }, [enableYandexId]);

  return init;
}